import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/match/:id_partido/:mode',
            name: 'match',
            props: true,
            component: () => import('./views/Match.vue')
        },
        {
            path: '/matches',
            name: 'matches',
            component: () => import('./views/Matches.vue')
        },
        {
            path: '/sheets',
            name: 'sheets',
            component: () => import('./views/Sheets.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('./views/Settings.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue')
        },
        {
            path: '/linkAccount',
            name: 'linkAccount',
            component: () => import('./views/LinkAccount.vue')
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    // Ensure auth state is initialized
    await store.dispatch('auth/initializeAuth');
    
    const isAuthenticated = store.getters['auth/isAuthenticated'];

    if (to.name !== 'login' && to.name !== 'register' && !isAuthenticated) {
        next({ name: 'login' });
    } else {
        next();
    }
})

export default router;